<template>
    <NotificationsManager />
    <header class="content-grid">
        <div>
            <div class="main-logo">
                <NuxtLink to="/">
                    <img src="/logo.svg" width="64" height="64" alt="Foldwrap logo" />
                </NuxtLink>
            </div>

            <div class="menu">
                <ul>
                    <li class="dropdown-container">
                        <span class="dropdown-trigger" @click="toggleProductDropdown" @mouseenter="showProductDropdown" @mouseleave="hideProductDropdown">
                            Product
                        </span>
                        <div v-if="isProductDropdownOpen" class="dropdown-menu" @mouseenter="showProductDropdown" @mouseleave="hideProductDropdown">
                            <NuxtLink class="dropdown-item" to="/ai" @click="closeProductDropdown">
                                AI Banner Generator
                                <div class="product-description">
                                    Create <span class="hidden md:inline">and edit </span>animated ads with AI<span class="hidden md:inline"
                                        >, iterate faster</span
                                    >
                                </div>
                            </NuxtLink>

                            <NuxtLink class="dropdown-item" to="/figma_plugin" @click="closeProductDropdown">
                                Figma plugin
                                <div class="product-description">Import <span class="hidden md:inline">and auto-animate </span>designs from Figma</div>
                            </NuxtLink>
                        </div>
                    </li>
                    <li>
                        <NuxtLink to="/pricing">Pricing</NuxtLink>
                    </li>
                    <li class="extra-link">
                        <NuxtLink to="/blog">Blog</NuxtLink>
                    </li>
                    <li>
                        <ClientOnly>
                            <div v-if="auth_store.is_authenticated" class="inline">
                                <NuxtLink to="/user/account">Account</NuxtLink>
                                <!-- <UIAvatar
                                    v-if="auth_store.user_id_getter"
                                    class="ml-2 -mt-1 cursor-pointer"
                                    :name="auth_store.user_id_getter"
                                    :size="28"
                                    v-on:click="navigateTo('/user/account')"
                                /> -->
                            </div>
                            <div v-else class="inline">
                                <NuxtLink to="/user/signup" class="get-started">Get Started</NuxtLink>
                                <NuxtLink to="/user/signup" class="start">Start</NuxtLink>
                                <span class="get-started-free-badge">Free</span>
                            </div>
                            <template #fallback>
                                <div class="inline">
                                    <NuxtLink to="/user/signup" class="get-started">Get Started</NuxtLink>
                                    <NuxtLink to="/user/signup" class="start">Start</NuxtLink>
                                    <span class="get-started-free-badge">Free</span>
                                </div>
                            </template>
                        </ClientOnly>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth'

const auth_store = useAuthStore()

// Dropdown state management
const isProductDropdownOpen = ref(false)
let dropdownTimeout = null

const showProductDropdown = () => {
    if (dropdownTimeout) {
        clearTimeout(dropdownTimeout)
        dropdownTimeout = null
    }
    isProductDropdownOpen.value = true
}

const hideProductDropdown = () => {
    dropdownTimeout = setTimeout(() => {
        isProductDropdownOpen.value = false
    }, 100) // Small delay to prevent flickering when moving between trigger and menu, was 150, lowered by me
}

const toggleProductDropdown = () => {
    isProductDropdownOpen.value = !isProductDropdownOpen.value
}

const closeProductDropdown = () => {
    if (dropdownTimeout) {
        clearTimeout(dropdownTimeout)
        dropdownTimeout = null
    }
    isProductDropdownOpen.value = false
}
</script>

<style lang="scss" scoped>
.get-started {
    display: inline;

    @media (max-width: 420px) {
        display: none;
    }
}

.start {
    display: none;

    @media (max-width: 420px) {
        display: inline;
    }
}

.dropdown-container {
    position: relative;
}

.dropdown-trigger {
    /* background: none; */
    /* border: none; */
    color: var(--color-link);
    cursor: pointer;
    /* display: flex; */
    // align-items: center;
    /* gap: 0.25rem; */
    /* font: inherit; */
    /* color: inherit; */
    // text-decoration: none;
    // padding: 0;
    user-select: none;
}

.dropdown-menu {
    position: absolute;
    /* top: 100%; */
    left: -18px;
    min-width: 220px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: var(--ui-border-radius);
    /* box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); */
    padding: 10px 16px;
    z-index: 50;
    /* margin-top: 10px; */
    display: flex;
    flex-direction: column;
    gap: 10px;

    .product-description {
        display: block;
        text-transform: none;
        font-size: 0.8em;
        margin-top: 0.2em;
        color: #666;
    }
}

.dropdown-item {
    display: block;
    /* padding: 0.5rem 1rem; */
    /* color: #374151; */
    /* text-decoration: none; */
    transition: background-color 0.15s ease;
    white-space: nowrap;
}

.get-started-free-badge {
    display: inline-block;
    font-size: 10px;
    background-color: var(--color-primary);
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
    padding: 2px 5px;
    border-radius: 4px;
    margin-left: 4px;
    color: #1f1f1f;
    rotate: -5deg;
    position: relative;
    top: -10px;
    user-select: none;

    @media (max-width: 460px) {
        display: none;
    }
}
</style>
